import React$1 from 'react';
import styles from './Heading.scss.js';
function Heading(_ref) {
  var _ref$element = _ref.element,
    Element = _ref$element === void 0 ? 'h2' : _ref$element,
    children = _ref.children;
  return /*#__PURE__*/React$1.createElement(Element, {
    className: styles.Heading
  }, children);
}
export { Heading };